import React, { FC } from 'react'
import { LinkButton } from '@/atoms/Button'
import { FlexColumn, FlexRow } from '@/atoms/FlexContainers'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { Image } from '@/atoms/Image'
import { HeadingXS, ParagraphMD, ParagraphSM, TitleMD } from '@/atoms/Text'
import { slugs } from '@/constants'
import { Modal } from '@/molecules/Modal'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

interface Props {
  theatricalSlug: string
  isOpen: boolean
  onClose: () => void
}
export const LastRodeoEventModal: FC<Props> = ({ theatricalSlug, isOpen, onClose }) => {
  const { t } = useTranslate('tickets')

  if (theatricalSlug === slugs.theLastRodeo) {
    return (
      <Modal
        backgroundScreenColor="black"
        isOpen={isOpen}
        onClose={onClose}
        panelClasses="w-full !max-w-[361px] md:!max-w-[600px] !overflow-visible !bg-[#E5DFD3]/20 shadow-dark-4 rounded-3xl !p-0 relative text-left"
        transition="appear"
        className="z-[99999]"
        childWrapperClassName="!m-0"
      >
        <div className="absolute right-6 top-6 z-50 cursor-pointer rounded-full bg-gray-300 p-[10px]" onClick={onClose}>
          <CloseIcon color="black" size={20} />
        </div>

        <div className="absolute inset-0 h-full w-full overflow-hidden rounded-3xl">
          <Image src="/v1746155548/the-last-rodeo/premiere2.webp" alt="" fill className="object-cover" />
          <div className="absolute inset-0 bg-[#FFFBF5]/80"></div>
        </div>

        <FlexColumn className={'relative top-0 z-10 flex w-full justify-center gap-6 p-6 pt-10 md:gap-8 md:p-12'}>
          <FlexRow className={' justify-center md:h-auto'}>
            <Image
              src="/v1746139817/the-last-rodeo/Frame_1261157975.webp"
              className={'h-[128px] w-auto md:h-[172px]'}
              alt=""
              width={290}
              height={170}
            />
          </FlexRow>
          <FlexRow className={'justify-center'}>
            <Image
              src="/v1746140180/the-last-rodeo/premiere-ticket-graphic.webp"
              className={'h-[111px] w-auto md:h-[131px]'}
              alt=""
              width={204}
              height={131}
            />
          </FlexRow>
          <FlexRow className={'justify-center'}>
            <FlexColumn className={'relative top-0 z-10 text-center'}>
              <HeadingXS weight={'bold'} className={'hidden pb-2 uppercase md:block'}>
                {t('tlrPremiereYouvebeenInvited', 'YOU HAVE BEEN INVITED')}
              </HeadingXS>
              <TitleMD weight={'bold'} className={'pb-2 uppercase md:hidden'}>
                {t('tlrPremiereYouvebeenInvited', 'YOU HAVE BEEN INVITED')}
              </TitleMD>
              <ParagraphMD weight={'medium'} className={'hidden md:block'}>
                <Translate t={t} i18nKey="tlrPremiereJoinUs">
                  Join us <strong>May 12, 2025,</strong> in Fort Worth for a rodeo party, live music, games, and a
                  private screening of The Last Rodeo, plus a Red Carpet walk, Q&A, and After Party!
                </Translate>
              </ParagraphMD>
              <ParagraphSM weight={'medium'} className={'md:hidden'}>
                <Translate t={t} i18nKey="tlrPremiereJoinUs">
                  Join us <strong>May 12, 2025,</strong> in Fort Worth for a rodeo party, live music, games, and a
                  private screening of The Last Rodeo, plus a Red Carpet walk, Q&A, and After Party!
                </Translate>
              </ParagraphSM>
            </FlexColumn>
          </FlexRow>
          <FlexRow className={'justify-center'}>
            <LinkButton
              className="m-auto w-full px-6 py-3 md:w-fit"
              variant="gray-900"
              onClick={onClose}
              target={'_blank'}
              href={'https://shop.angel.com/products/the-last-rodeo-live-premiere-event'}
            >
              {t('TexasLearnMore', 'Learn More')}
            </LinkButton>
          </FlexRow>
        </FlexColumn>
      </Modal>
    )
  }

  return null
}
